module.exports = __webpack_public_path__ + "img/storage-1.6537b651.png";